import { reportConstants } from '../../../../constants/reports';

export const filterTransactionFieldsByEnv = (fields: string[]): string[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter(
			(f) => f !== reportConstants.REPORT_AAMS_TICKET_ID && f !== reportConstants.REPORT_SESSION_TYPE
		);
	} else {
		result = result.filter(
			(f) => f !== reportConstants.REPORT_HAND_DETAILS && f !== reportConstants.REPORT_AAMS_TICKET_ID
		);
	}

	return result;
};
